import getMomentDateObj from "./getMomentDateObj"
import getMomentNow from "./getMomentNow"
import isCurrentPerformance from "./isCurrentPerformance"
import seperateAttributes from "./seperateAttributes"

const getAttributesDisplaySettings = (technologyAttributes, performances, filterValue, filterType, queryStringValues, performanceFilterIsSet, translation) => {
    let performancesAttributes = []
    const { timezone } = translation
    const dateNow = getMomentNow(timezone)
    if(performanceFilterIsSet) {
        if(filterType && filterType === 'technical' && filterValue !== 'Vorschau') {
            performances.map(performance => {
                const {attributes, timeUtc} = performance
                if(isCurrentPerformance(dateNow, getMomentDateObj(timeUtc, timezone))) {
                    const hasAttribute = _.find(attributes, attr => {
                        return attr.name === filterValue
                    })
                    
                    if(hasAttribute) {
                        attributes.map(attribute => {
                            if(!_.find(performancesAttributes, (attr) => {
                                return attr.id === attribute.id
                            })) {
                                performancesAttributes.push(attribute)
                            }
                        })
                    }
                }
            })
        } else if(queryStringValues && (queryStringValues.theatreName || queryStringValues.seatClasses || queryStringValues.technical)) { 
            performances.map(performance => {
                const {attributes, timeUtc, seatClasses, theatreID} = performance
                
                if(isCurrentPerformance(dateNow, getMomentDateObj(timeUtc, timezone))) {
                    if(queryStringValues.technical) {
                        const queryStringValue = queryStringValues.technical
                        const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
        
                        const hasAttribute = _.find(attributes, attr => {
                            return _.contains(filterValues, attr.id)
                        })
                        
                        if(hasAttribute) {
                            attributes.map(attribute => {
                                if(!_.find(performancesAttributes, (attr) => {
                                    return attr.id === attribute.id
                                })) {
                                    performancesAttributes.push(attribute)
                                }
                            })
                        }
                    }
                    if(queryStringValues.seatClasses) {
                        const queryStringValue = queryStringValues.seatClasses
                        const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
        
                        const hasAttribute = _.find(seatClasses, seatClass => {
                            return _.contains(filterValues, seatClass.id)
                        })
                        
                        if(hasAttribute) {
                            attributes.map(attribute => {
                                if(!_.find(performancesAttributes, (attr) => {
                                    return attr.id === attribute.id
                                })) {
                                    performancesAttributes.push(attribute)
                                }
                            })
                        }
                    }
                    if(queryStringValues.theatreName) {
                        const queryStringValue = queryStringValues.theatreName
                        const filterValues = Array.isArray(queryStringValue) ? queryStringValue : [queryStringValue]
        
                        const hasAttribute = _.contains(filterValues, theatreID)
                        
                        if(hasAttribute) {
                            attributes.map(attribute => {
                                if(!_.find(performancesAttributes, (attr) => {
                                    return attr.id === attribute.id
                                })) {
                                    performancesAttributes.push(attribute)
                                }
                            })
                        }
                    }
                }
            })
        } else {
            performancesAttributes = technologyAttributes
        }
    } else {
        performancesAttributes = technologyAttributes
    }
    
    const {technologyAttributesWithIcons, technologyAttributesWithoutIcons} = seperateAttributes(performancesAttributes)

    const noAttributesWithIconsToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) ? true : false
    const noAttributesWithoutIconsToDisplay = technologyAttributesWithoutIcons.length === 0 ? true : false
    const noAttributesToDisplayWithSchnäppchen = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) && (technologyAttributesWithoutIcons.length === 0 || (technologyAttributesWithoutIcons.length === 1 && technologyAttributesWithoutIcons[0].id === "schnaeppchen")) ? true : false
    const noAttributesToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) && (technologyAttributesWithoutIcons.length === 0) ? true : false

    return {
        technologyAttributesWithIcons: technologyAttributesWithIcons,
        technologyAttributesWithoutIcons: technologyAttributesWithoutIcons,
        noAttributesToDisplayWithSchnäppchen: noAttributesToDisplayWithSchnäppchen,
        noAttributesToDisplay: noAttributesToDisplay,
        noAttributesWithIconsToDisplay: noAttributesWithIconsToDisplay,
        noAttributesWithoutIconsToDisplay: noAttributesWithoutIconsToDisplay
    }
}

export default getAttributesDisplaySettings